export const USER_NAV_KEY = {
  ORDER: 'order',
  ASSET: 'asset',
  PERSON: 'person',
  I18N: 'i18n',
  CURRENCY: 'currency',
  DOWNLOAD: 'download',
};

export const USER_NAV_KEY_LIST = [
  USER_NAV_KEY.ORDER,
  USER_NAV_KEY.ASSET,
  USER_NAV_KEY.PERSON,
  USER_NAV_KEY.I18N,
  USER_NAV_KEY.CURRENCY,
  USER_NAV_KEY.DOWNLOAD,
];
